import { render, staticRenderFns } from "./Couriers.vue?vue&type=template&id=511f5671&scoped=true&"
import script from "./Couriers.vue?vue&type=script&lang=js&"
export * from "./Couriers.vue?vue&type=script&lang=js&"
import style0 from "./Couriers.vue?vue&type=style&index=0&id=511f5671&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511f5671",
  null
  
)

component.options.__file = "Couriers.vue"
export default component.exports